import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils/formatting";

type SalesBoxProps = {
    value: ReactNode | undefined;
    unit: string;
};

export const SalesBox = (props: SalesBoxProps) => {
    const { i18n } = useTranslation();
    const language = i18n.resolvedLanguage ?? i18n.language;

    return props.value ?
            <Box sx={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
                <Typography variant="h5">{formatNumber(props.value.toString(), language)}</Typography>
                <Typography variant="body-medium" sx={{ color: "#A3A2A0" }}>
                    {props.unit}
                </Typography>
            </Box>
        :   "-";
};
